import { render } from "./AdditionalFields.vue?vue&type=template&id=8c19255e"
import script from "./AdditionalFields.vue?vue&type=script&lang=js"
export * from "./AdditionalFields.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__